export default "__VITE_ASSET__BymqOv7C__"